'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('DeleteModuleDialogCtrl', DeleteModuleDialogCtrl);

  DeleteModuleDialogCtrl.$inject = ['$scope', '$mdDialog', 'Module', 'Project', 'errorMessageService',
    '$log', '$document', 'Labels'];

  function DeleteModuleDialogCtrl ($scope, $mdDialog, Module, ProjectAPI, errorMessageService,
    $log, $document, Labels) {
    $scope.dialogCtrl = function (dialogScope, mdDialog) {
      dialogScope.cancel = function () {
        mdDialog.cancel();
      };

      dialogScope.delete = function () {
        let deletePromise;
        if (dialogScope.project) {
          deletePromise = ProjectAPI.deactivateModule({
            id: dialogScope.project._id,
            paramId: dialogScope.module._id,
            versionId: dialogScope.project.versionId,
          });
        } else {
          deletePromise = Module.delete({id: dialogScope.module._id});
        }

        return deletePromise.$promise.then(function (data) {
          mdDialog.hide();
          errorMessageService.showSuccess(Labels.getLabel('deletedmodule'));
          dialogScope.callback(data);
        }).catch(function (err) {
          $log.error('error while deleting module:', err);
        });
      };
    };

    $scope.LABELS = Labels;

    $scope.dialogCtrl.$inject = ['$scope', '$mdDialog'];

    $scope.open = function (ev, callback, module, project) {
      $scope.module = module;
      $scope.callback = callback;
      $scope.project = project;

      $mdDialog.show({
        controller: $scope.dialogCtrl,
        templateUrl: 'app-legacy/module/delete-module-dialog/delete_module_dialog.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope.$new()
      })
        .then(function (name) {
          // called on .hide()
        }, function (err) {
          // called on .close();
        });
    };
  }

})();
